<!-- APP HEADER -->
@if (showAppHeader) {
<app-header [hidePortal]="hidePortalMenu" [showTucieloLogo]="!showImage"></app-header>
}

<!-- ALL THE TEXT -->
<ng-container>
  <ng-content></ng-content>
</ng-container>
